import Modal, { ModalRef } from '@/components/@IntranetLibrary/Modal';
import React, { useRef } from 'react';
import useModal from '@/hooks/useModal';
import { useFormContext } from 'react-hook-form';
import { RecordFilter } from '@/types/api';
import { copyClipBoardText } from '@/utils';
import process from 'process';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from '@/hooks/global-tools';
import usePlatform from '@/components/Record/hooks/usePlatform';
import ShareComponent from '@/components/Record/ShareButton/useShareModal/ShareComponent';
import CopyLinkButton from '@/components/Record/ShareButton/useShareModal/CopyLinkButton';

type P = {
  handleClose?: () => void;
};

const useShareModal = ({ handleClose }: P = {}) => {
  const { isMobilePath } = usePlatform();
  const { t } = useTranslation();
  const shareModalRef = useRef<ModalRef>(null);

  const { openModal, closeModal } = useModal(shareModalRef, undefined, () => {
    handleClose?.();
  });

  const { getValues } = useFormContext<RecordFilter>();

  const { showSuccess } = useSnackbar();

  const copyProfileCardLink = async () => {
    const resultCopy = await copyClipBoardText(
      `${process.env.NEXT_PUBLIC_ORIGIN_URL}/talkflow/${getValues('docId')}`,
    );
    if (resultCopy) {
      showSuccess({
        message: t('문서 링크가 복사되었습니다.'),
        duration: 3000,
      });
    }
  };

  const ShareModal = (
    <div>
      <Modal
        ref={shareModalRef}
        title={t('공유하기')}
        size={isMobilePath ? 'expand' : 'small'}
        handleClose={closeModal}
        sx={{
          '.modal-body': { overflow: 'visible', paddingBottom: '0' },
          '.small': {
            minWidth: '400px !important',
          },
          '.modal-footer': { backgroundColor: 'var(--dk-bg, white)', paddingTop: '0' },
          '.modal-inner': {
            minWidth: isMobilePath ? '0' : '',
            overflow: 'visible',
          },
        }}
        footerContent={
          !isMobilePath && (
            <div
              style={{
                borderTop: '1px solid var(--dk-line, #E7E9EC)',
                marginTop: '12px',
                paddingTop: '12px',
              }}
            >
              <CopyLinkButton onClick={copyProfileCardLink} />
            </div>
          )
        }
      >
        <ShareComponent />
      </Modal>
    </div>
  );

  return {
    openModal,
    ShareModal,
    closeModal,
  };
};

export default useShareModal;
